import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mui';
import './show-more.scss';

const ShowMore = ({ onClick, open }) => {
  const label = `Show ${open ? 'less' : 'more'} results`;
  return (
    <div
      styleName="show-more-container"
      onClick={onClick}
      onKeyDown={event => (event.key === 'Enter' || event.key === ' ') && onClick()}
      role="button"
      tabIndex={0}
      aria-label={label}
    >
      <div styleName="icon">
        <Icon role="img" aria-hidden="true">more_horiz</Icon>
      </div>
      <div styleName="text">
        SHOW { open ? 'LESS' : 'MORE' } RESULTS
      </div>
    </div>
  );
};

ShowMore.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool
};

export default ShowMore;
